/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import moment from 'moment';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

import LoadingComponent from 'components/loading';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';
import TooltipComponent from 'components/toolTips/index';

import ConfirmingAvailableCreditLimitChartComponent from './chart';

import GetPerformanceRequest from 'models/requests/buyers/getPerformanceRequest';

import ConfirmingService from 'services/ConfirmingService';

type ConfirmingAvailableCreditLimitComponentProps = {
  activeCompanyId: number;
};

type ConfirmingAvailableCreditLimitComponentState = {
  data: any;
  isLoading: boolean;
  maxCreditLimit: number;
};

class ConfirmingAvailableCreditLimitComponent extends React.Component<ConfirmingAvailableCreditLimitComponentProps, ConfirmingAvailableCreditLimitComponentState> {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true
    };
  }

  componentDidMount() {
    this.getConfirmingAvailableCreditLimitData();
  }

  getConfirmingAvailableCreditLimitData = async () => {
    try {
      const resp = await ConfirmingService.getAvailableCreditLimit(this.props.activeCompanyId);

      this.setState({
        data: resp.availableCreditLimitDataSeries,
        isLoading: false,
        maxCreditLimit: resp.maxCreditLimit
      });
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    if (this.state.isLoading) {
      return (<LoadingComponent />);
    }

    return (
      <React.Fragment>
        <Box pageName="tooltip.confirming.dashboard" elementName="availablecreditlimit.title">
          <TooltipComponent pageName="tooltip.confirming.dashboard" elementName="availablecreditlimit.title">
            <PageSubTitleViewComponent id="confirming.dashboard.availablecreditlimit" />
          </TooltipComponent>
        </Box>
        <Box mt={3}>
          <Paper elevation={0} style={{ textTransform: 'uppercase' }}>
            <Box p={5}>
              <ConfirmingAvailableCreditLimitChartComponent
                chartData={this.state.data}
                chartUnitX=""
                chartUnitY="€"
                title="confirming.dashboard.availablecreditlimit"
                maxUnitY={this.state.maxCreditLimit}
              />
            </Box>
          </Paper>
        </Box>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id
});

export default connect(mapStateToProps)(ConfirmingAvailableCreditLimitComponent);
